import React, {useEffect, useState} from "react";
import {Button, Divider, Stack, Typography} from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import {useNavigate} from "react-router-dom";
import {dataManager} from "../../Broadtask";
import DataSourceCard from "./DataSourceCard";
import {buttonStyle, sectionStack} from "../../../AppStyles";

const DIOSManagerPane = (props) => {

    const navigate = useNavigate();

    const [dataSources, setDataSources] = useState(null);

    useEffect(() => {
        reload(false);
    }, []);

    function onRefresh()
    {
        reload(true);
    }

    function reload(force)
    {
        dataManager.getDIOSManager().getDIOS(force, (sources) => {
            setDataSources(sources);
        });
    }

    function onCreate()
    {
        navigate("../dios/create");
    }

    return (
        <Stack direction="column" spacing={1} padding={1} width="100%" alignItems="flex-start" justifyContent="flex-start"
               sx={sectionStack}>
            <Stack direction="row" width="100%"
                   justifyContent="space-between"
                   padding={1} spacing={1}>
                <Stack direction="row" spacing={1} alignItems="center">
                    <img src="/icons/dios.png" width={32} height={32}/>
                    <Typography variant="h6">Data Sources</Typography>
                </Stack>
                <Stack direction="row" spacing={1}>
                    <Button onClick={onCreate}
                            sx={buttonStyle}
                            startIcon={<AddCircleOutlineIcon />}>CREATE</Button>
                </Stack>
            </Stack>
            <Divider orientation="horizontal" variant="left" flexItem />
            <Stack direction="row" alignItems="center" spacing={1} padding={1} width="100%" minHeight={100}
                   useFlexGap sx={{ flexWrap: "wrap", backgroundColor: '#2A333A'}}>
                {
                    dataSources === null ?
                        <Typography variant="h6">Loading...</Typography>:
                        dataSources.map(nextSource => {
                            return (<DataSourceCard key={"dios_" + nextSource.diosUID} entry={nextSource} />)
                        })
                }
            </Stack>
            <Divider orientation="horizontal" variant="left" flexItem />
        </Stack>
);
}

export default DIOSManagerPane;
